import {
  getIssuesList,
  saveIssuesAPI,
  deleteIssuesAPI,
  getStatusCombo,
  getPriorityCombo,
  getProductListCombo,
  getUsersCombo
} from '../../services/Issues/IssueService';

export const fetchIssues = async (payload) => {
  try {
    const response = await getIssuesList(payload || {});

    if (response && response.success) {
      return response.data || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching issues',
        variant: 'error'
      });
      console.log('Error fetching issues:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching issues',
      variant: 'error'
    });
    console.log('Error fetching issues:', err);
    return [];
  }
};

export const fetchProductCombo = async () => {
  try {
    const response = await getProductListCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      console.log('Error fetching products:', response?.message);
      return [];
    }
  } catch (err) {
    console.log('Error fetching products:', err);
    return [];
  }
};

export const fetchStatusCombo = async () => {
  try {
    const response = await getStatusCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      console.log('Error fetching status:', response?.message);
      return [];
    }
  } catch (err) {
    console.log('Error fetching status:', err);
    return [];
  }
};

export const fetchPriorityCombo = async () => {
  try {
    const response = await getPriorityCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      console.log('Error fetching priority:', response?.message);
      return [];
    }
  } catch (err) {
    console.log('Error fetching priority:', err);
    return [];
  }
};

export const fetchUsersCombo = async () => {
  try {
    const response = await getUsersCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      console.log('Error fetching users:', response?.message);
      return [];
    }
  } catch (err) {
    console.log('Error fetching users:', err);
    return [];
  }
};

export const saveIssues = async (payload, successMsg, errorMsg) => {
  try {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const apiPayload = {
      ...payload,
      createdGUID: user.userGUID,
      createdByGUID: user.userGUID,
      modifiedGUID: user.userGUID,
      createdDate: new Date(),
      modifiedDate: new Date()
    };
    const response = await saveIssuesAPI(apiPayload);

    if (response && response.success) {
      window.showSnackbar({
        message: successMsg || 'Issue saved successfully',
        variant: 'success'
      });
      return response;
    } else {
      window.showSnackbar({
        message: errorMsg || response?.message || 'An error occurred while saving issue',
        variant: 'error'
      });
      console.log('Error saving issue:', response?.message);
      return response;
    }
  } catch (err) {
    window.showSnackbar({
      message: errorMsg || err.message || 'An error occurred while saving issue',
      variant: 'error'
    });
    console.log('Error saving issue:', err);
    return { success: false };
  }
};

export const deleteIssues = async (issueGUID, successMsg, errorMsg) => {
  try {
    const response = await deleteIssuesAPI(issueGUID);

    if (response && response.success) {
      window.showSnackbar({
        message: successMsg || 'Issue deleted successfully',
        variant: 'success'
      });
      return response;
    } else {
      window.showSnackbar({
        message: errorMsg || response?.message || 'An error occurred while deleting issue',
        variant: 'error'
      });
      console.log('Error deleting issue:', response?.message);
      return response;
    }
  } catch (err) {
    window.showSnackbar({
      message: errorMsg || err.message || 'An error occurred while deleting issue',
      variant: 'error'
    });
    console.log('Error deleting issue:', err);
    return { success: false };
  }
};
